import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import Player from "./Players";
import Play from "../../assets/images/verboden/play.png";
import avatar from "../../assets/images/OCH/avatar.png";
import queMark from "../../assets/images/CT/queMark.png";
// import Cross from "../../assets/images/verboden/cross.png";
import XIcon from "../../assets/images/OCH/X.png";
import _ from "lodash";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Alert from "../shared/common/alert";
import Socket from "../../socket/socket";
import * as paramsAction from "../../redux/gameParams/actions";

const CTPlayers = (props) => {
  const roomData = _.get(props, "gameReducer.roomObj");
  const gameName = _.get(props, "gameReducer.gameName");
  const startText = _.get(props, "paramsReducer.gameObj.1_lobby.start_button");
  const allPlayers = _.get(roomData, "users");
  const usersChanged = _.get(props, "usersChanged");
  const status = _.get(roomData, "game_state.status");

  useEffect(() => {
    return Socket.addListener("update-status", () => {
      props.history.push("/ct-game");
    });
  }, []);

  useEffect(() => {
    if (status != "Joining") {
      let gameObj = props.gameReducer;
      let dataObj = {
        gameName:
          gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
      };
      props.getGameData(dataObj);
      if (Object.keys(props.paramsReducer.gameObj).length > 0) {
        props.history.push("/ct-game");
      }
    }
  }, [status, props.paramsReducer.gameObj]);

  const onStartGame = () => {
    if (allPlayers && allPlayers.length < 2) {
      Alert(400, "Need at least 2 players to start the game");
      return;
    } else {
      let data = {
        action: "update-status",
        roomId: roomData.id,
        tableTopName: gameName
      };
      Socket.sendMessage(data);
    }
  };

  return (
    <div className="CT-players-wrapper">
      <div className="players-wrapper">
        <Player usersChanged={usersChanged} />
        {allPlayers && allPlayers.length < 6 && (
          <div className="quemark">
            <img src={queMark} className="CT-player-image" alt="queMark" />
          </div>
        )}
      </div>
      <div className="start-btn">
        <Button onClick={onStartGame}>{startText}</Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});
const mapDispatchToProps = (dispatch) => {
  return {
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CTPlayers);
